module.exports = __webpack_public_path__ + "static/media/handoff-confirm.9622330a.png";